export default "__VITE_ASSET__CLR4xzCj__"